import { z } from "zod";

const TaskMilestoneSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    taskInstanceId: z.string().describe("Links this milestone to its TaskInstance container."),
    title: z.string().min(1, "Milestone title is required."),
    target_date: z.coerce.date().optional().nullable(),
    status: z.enum(['active', 'planned', 'done', 'cancelled']).default('active'),
    owner: z.string().optional().nullable(),
    outcome: z.string().optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default TaskMilestoneSchema;
